import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { id: "dashboard" };
const _hoisted_2 = { class: "flex items-center mb-2" };
const _hoisted_3 = { class: "mb-0" };
const _hoisted_4 = {
    key: 0,
    class: "-mt-4 text-slate-500"
};
const _hoisted_5 = { class: "flex items-center my-4" };
const _hoisted_6 = {
    key: 0,
    class: "admin-form flex items-center"
};
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "admin-form flex items-center pr-2" };
const _hoisted_9 = ["value"];
const _hoisted_10 = {
    key: 0,
    class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
};
const _hoisted_11 = { class: "flex col-span-1 items-center section-content py-8" };
const _hoisted_12 = { class: "flex-1 px-4 text-right" };
const _hoisted_13 = { class: "text-3xl font-medium py-4" };
const _hoisted_14 = { class: "flex col-span-1 items-center section-content py-4" };
const _hoisted_15 = { class: "flex-1 px-4 text-right" };
const _hoisted_16 = { class: "text-3xl font-medium py-4" };
const _hoisted_17 = { class: "flex col-span-1 items-center section-content py-4" };
const _hoisted_18 = { class: "flex-1 px-4 text-right" };
const _hoisted_19 = { class: "text-3xl font-medium py-4" };
const _hoisted_20 = { class: "flex col-span-1 items-center section-content py-4" };
const _hoisted_21 = { class: "flex-1 px-4 text-right" };
const _hoisted_22 = { class: "text-3xl font-medium py-4" };
const _hoisted_23 = { key: 1 };
const _hoisted_24 = {
    key: 2,
    class: "admin-table"
};
const _hoisted_25 = {
    key: 3,
    class: "admin-table"
};
const _hoisted_26 = { class: "colored-row" };
const _hoisted_27 = { class: "w-16" };
const _hoisted_28 = ["aria-labelledby"];
const _hoisted_29 = ["id"];
const _hoisted_30 = { class: "text-left" };
const _hoisted_31 = { class: "block" };
const _hoisted_32 = ["href"];
const _hoisted_33 = { class: "font-medium" };
const _hoisted_34 = { class: "sr-only" };
const _hoisted_35 = { key: 4 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_3, "Welcome back " + _toDisplayString(_ctx.dashboard.app.auth.name), 1),
                (_ctx.dashboard.app)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.dashboard.account_metrics.name), 1))
                    : _createCommentVNode("", true)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("nav", null, "   ", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "flex-1 font-medium text-lg" }, " Campaigns ", -1)),
            (_ctx.dashboard.isAdminUser())
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("select", {
                        name: "account",
                        id: "account",
                        class: "ml-2",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.dashboard.account) = $event)),
                        onChange: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.dashboard.selectAccount()), ["prevent"]))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app.accounts, (account) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: account.slug
                            }, _toDisplayString(account.name), 9, _hoisted_7));
                        }), 256))
                    ], 544), [
                        [_vModelSelect, _ctx.dashboard.account]
                    ])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                    name: "currency",
                    id: "currency",
                    class: "ml-2",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.dashboard.currency) = $event)),
                    onChange: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.dashboard.selectCurrency()), ["prevent"]))
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app.currencies, (currency) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: currency.iso3
                        }, _toDisplayString(currency.iso3), 9, _hoisted_9));
                    }), 256))
                ], 544), [
                    [_vModelSelect, _ctx.dashboard.currency]
                ])
            ])
        ]),
        (_ctx.dashboard.account_metrics)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                _createElementVNode("li", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-16 h-16 text-slate-300"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "font-medium text-slate-500" }, "Active Campaigns", -1)),
                        _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.dashboard.account_metrics.active_campaigns), 1)
                    ])
                ]),
                _createElementVNode("li", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-16 h-16 text-slate-300"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "font-medium text-slate-500" }, "Upcoming Campaigns", -1)),
                        _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.dashboard.account_metrics.upcoming_campaigns), 1)
                    ])
                ]),
                _createElementVNode("li", _hoisted_17, [
                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-16 h-16 text-slate-300"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
                        }),
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_18, [
                        _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "font-medium text-slate-500" }, "Total Value", -1)),
                        _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.f.formatCurrency(_ctx.dashboard.currency, _ctx.dashboard.account_metrics.total_value / 100)), 1)
                    ])
                ]),
                _createElementVNode("li", _hoisted_20, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-16 h-16 text-slate-300"
                    }, [
                        _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "font-medium text-slate-500" }, "Redeemed Value", -1)),
                        _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.f.formatCurrency(_ctx.dashboard.currency, _ctx.dashboard.account_metrics.redeemed_value / 100)), 1)
                    ])
                ])
            ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_23, [
                _createVNode(_component_Loading, { message: false })
            ])),
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex items-center my-4" }, [
            _createElementVNode("h2", { class: "flex-1 font-medium text-lg" }, " Orders ")
        ], -1)),
        (_ctx.dashboard.recent_orders && _ctx.dashboard.recent_orders.length === 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_24, [...(_cache[14] || (_cache[14] = [
                    _createStaticVNode("<div class=\"no-results panel p-10 mt-4\"><div class=\"text-slate-300 my-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-20 w-20 mx-auto\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z\"></path></svg></div><h2 class=\"text-slate-600 font-medium text-2xl text-center\">No Recent orders</h2><p class=\"text-center mt-4 text-sm text-slate-700\"> We could not find any orders. </p></div>", 1)
                ]))]))
            : (_ctx.dashboard.recent_orders)
                ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                                _createElementVNode("table", null, [
                                    _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { scope: "col" }, " "),
                                            _createElementVNode("th", { scope: "col" }, "Order Reference / Campaign"),
                                            _createElementVNode("th", { scope: "col" }, "Order Details"),
                                            _createElementVNode("th", { scope: "col" }, " "),
                                            _createElementVNode("th", { scope: "col" }, " "),
                                            _createElementVNode("th", { scope: "col" }, " ")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.recent_orders, (order) => {
                                            return (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                                                _createElementVNode("td", _hoisted_27, [
                                                    (_openBlock(), _createElementBlock("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        class: "h-10 w-10 text-slate-400 mx-auto",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        role: "img",
                                                        focusable: "false",
                                                        "aria-labelledby": order.reference
                                                    }, [...(_cache[15] || (_cache[15] = [
                                                            _createElementVNode("title", null, "Order", -1),
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                                            }, null, -1)
                                                        ]))], 8, _hoisted_28))
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", {
                                                        class: "block font-medium",
                                                        id: order.reference
                                                    }, _toDisplayString(order.reference), 9, _hoisted_29),
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'admin.campaign.manage', params: { account: order.account, slug: order.campaign } }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(order.campaign_name), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", _hoisted_30, [
                                                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.f.formatCurrency(order.order_currency, order.order_total / 100)), 1),
                                                    _createElementVNode("div", null, [
                                                        _createTextVNode(_toDisplayString(order.name) + " <", 1),
                                                        _createElementVNode("a", {
                                                            href: `mailto:${order.email}`,
                                                            target: "_blank"
                                                        }, _toDisplayString(order.email), 9, _hoisted_32),
                                                        _cache[16] || (_cache[16] = _createTextVNode(">", -1))
                                                    ])
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["status-box with-ping", {
                                                                'status-open': order.status === 'open',
                                                                'status-processing': order.status === 'processing',
                                                                'status-complete': order.status === 'complete',
                                                                'status-cancelled': order.status === 'cancelled',
                                                            }])
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(order.status), 1),
                                                        _cache[17] || (_cache[17] = _createElementVNode("span", null, [
                                                            _createElementVNode("span"),
                                                            _createElementVNode("span")
                                                        ], -1))
                                                    ], 2)
                                                ]),
                                                _cache[19] || (_cache[19] = _createElementVNode("td", null, "   ", -1)),
                                                _createElementVNode("td", _hoisted_33, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'admin.order.manage', params: { slug: order.reference } }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[18] || (_cache[18] = _createTextVNode(" Manage Order", -1)),
                                                            _createElementVNode("span", _hoisted_34, ", " + _toDisplayString(order.reference), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ])
                                            ]));
                                        }), 256))
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("section", _hoisted_35, [
                    _createVNode(_component_Loading, { message: false })
                ]))
    ]));
}
